import { useTheme } from "styled-components";

const Dollar = (props) => {
  const theme = useTheme();

  return (
    <svg viewBox="0 0 64 32" fill="none" {...props}>
      <title>Dollar</title>
      <rect width="64" height="32" rx="4" fill={theme.colors.success} />
      <g clipPath="url(#clip0_6376_35261)">
        <circle
          opacity="0.5"
          r="11.25"
          fill={theme.colors.success}
          stroke={theme.colors.text}
          strokeWidth="1.5"
        />
        <circle
          opacity="0.5"
          cy="32"
          r="11.25"
          fill={theme.colors.success}
          stroke={theme.colors.text}
          strokeWidth="1.5"
        />
        <circle
          opacity="0.5"
          cx="64"
          r="11.25"
          fill={theme.colors.success}
          stroke={theme.colors.text}
          strokeWidth="1.5"
        />
        <circle
          opacity="0.5"
          cx="64"
          cy="32"
          r="11.25"
          fill={theme.colors.success}
          stroke={theme.colors.text}
          strokeWidth="1.5"
        />
      </g>
      <g clipPath="url(#clip1_6376_35261)">
        <path
          opacity="0.5"
          d="M40.75 16C40.75 13.6794 39.8281 11.4538 38.1872 9.81282C36.5462 8.17187 34.3206 7.25 32 7.25C29.6794 7.25 27.4538 8.17187 25.8128 9.81282C24.1719 11.4538 23.25 13.6794 23.25 16C23.25 18.3206 24.1719 20.5462 25.8128 22.1872C27.4538 23.8281 29.6794 24.75 32 24.75C34.3206 24.75 36.5462 23.8281 38.1872 22.1872C39.8281 20.5462 40.75 18.3206 40.75 16ZM22 16C22 13.3478 23.0536 10.8043 24.9289 8.92893C26.8043 7.05357 29.3478 6 32 6C34.6522 6 37.1957 7.05357 39.0711 8.92893C40.9464 10.8043 42 13.3478 42 16C42 18.6522 40.9464 21.1957 39.0711 23.0711C37.1957 24.9464 34.6522 26 32 26C29.3478 26 26.8043 24.9464 24.9289 23.0711C23.0536 21.1957 22 18.6522 22 16ZM32.625 10.6875V11.5859C33.1523 11.625 33.6641 11.7656 34.1719 11.9102C34.2305 11.9258 34.293 11.9453 34.3516 11.9609C34.6836 12.0547 34.8789 12.3984 34.7891 12.7305C34.6992 13.0625 34.3516 13.2578 34.0195 13.168C33.9258 13.1406 33.832 13.1133 33.7383 13.0859C33.4453 13 33.1445 12.9141 32.8438 12.8711C32.0977 12.7617 31.4141 12.8555 30.918 13.0703C30.4141 13.2891 30.1914 13.582 30.1445 13.832C30.0742 14.2148 30.2266 14.4766 30.543 14.6797C30.957 14.9453 31.5781 15.1211 32.332 15.3359L32.3437 15.3398C33.0352 15.5352 33.8633 15.7734 34.4648 16.1875C35.207 16.6953 35.5508 17.5078 35.3867 18.3945C35.2305 19.2383 34.6484 19.8008 33.9102 20.0977C33.5234 20.2539 33.0859 20.3437 32.6172 20.3672V21.3125C32.6172 21.6563 32.3359 21.9375 31.9922 21.9375C31.6484 21.9375 31.3672 21.6563 31.3672 21.3125V20.3008C31.0508 20.25 30.5156 20.0977 30.1016 19.9727C29.832 19.8906 29.5625 19.8047 29.293 19.7188C28.9648 19.6094 28.7891 19.2578 28.8945 18.9297C29 18.6016 29.3555 18.4258 29.6836 18.5312C29.9414 18.6172 30.1992 18.6992 30.4609 18.7773C30.8984 18.9102 31.3477 19.0352 31.5586 19.0664C32.332 19.1797 32.9844 19.1172 33.4336 18.9336C33.8711 18.7578 34.0898 18.4922 34.1484 18.1641C34.2227 17.7539 34.0898 17.4453 33.75 17.2109C33.2812 16.8906 32.7031 16.7305 32.1523 16.5781C32.0625 16.5547 31.9688 16.5273 31.8828 16.5039C31.2148 16.3164 30.4375 16.0937 29.8633 15.7266C29.5469 15.5234 29.25 15.2539 29.0625 14.8789C28.8711 14.4961 28.8203 14.0664 28.9063 13.5977C29.0547 12.7891 29.6875 12.2266 30.4141 11.9141C30.7031 11.7891 31.0234 11.6953 31.3633 11.6367V10.6797C31.3633 10.3359 31.6445 10.0547 31.9883 10.0547C32.332 10.0547 32.6133 10.3359 32.6133 10.6797L32.625 10.6875Z"
          fill={theme.colors.text}
        />
      </g>
      <rect
        x="0.75"
        y="0.75"
        width="62.5"
        height="30.5"
        rx="3.25"
        stroke={theme.colors.text}
        strokeWidth="1.5"
      />
      <defs>
        <clipPath id="clip0_6376_35261">
          <rect width="64" height="32" rx="4" fill="white" />
        </clipPath>
        <clipPath id="clip1_6376_35261">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(22 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Dollar;
